import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito tener conocimientos de salud o nutrición?',
  answer: 'No. Esta guía está diseñada para cualquier persona, en lenguaje simple y directo. Si puedes leer, puedes aplicarla.'
}, {
  question: '¿En cuánto tiempo veré resultados?',
  answer: 'Muchas personas notan cambios en el sueño y la energía desde la primera semana. Los cambios físicos son visibles a partir del día 14-21.'
}, {
  question: '¿Funciona para hombres y mujeres?',
  answer: 'Sí. El cortisol afecta a ambos por igual. El protocolo está diseñado para cualquier persona adulta independientemente del género.'
}, {
  question: '¿Cómo recibo el e-book?',
  answer: 'Inmediatamente después de tu pago recibes un email con el enlace de descarga en PDF. Sin esperas.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'El protocolo está basado en evidencia científica. Si lo aplicas consistentemente durante 21 días y no notas ningún cambio, contáctanos directamente.'
}];
export const FaqSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-28 bg-brand-lightmint" data-id="element-14">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-17">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-19">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-20">
                  <span className="font-bold text-brand-charcoal pr-4" data-id="element-21">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-22">
                    <ChevronDown className="w-5 h-5 text-brand-emerald" data-id="element-23" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-24">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-25">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-26">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};